import React from 'react';
import { MisCardsListDiv } from './styles';
import MISChildCard from './misChildCard';
import { IRNComplianceSummary } from '../../../common/types';

interface MisCardListProps {
  childCardsData: IRNComplianceSummary[];
}

const MisCardList: React.FC<MisCardListProps> = ({ childCardsData }) => (
  <MisCardsListDiv>
    {childCardsData.map((item) => (
      <MISChildCard
        key={item.orgId}
        childCardData={item}
      />
    ))}
    <div className="Padding" />
  </MisCardsListDiv>
);

export default MisCardList;
